import React from "react";
import { CircularLoader, CustomIconButton, icon } from "../../../../../common/components";
import { translate } from "../../../../../common/providers";
import styles from "../ImportHeritagePanel.module.css";

const SaveActionIndicator = ({ saveState, hasUnsavedChanges, onSave }) => {
	const renderContent = () => {
		switch (saveState) {
			case "initial":
				return (
					<CustomIconButton
						disabled={!hasUnsavedChanges}
						icon={icon.faSave}
						iconColor="var(--color-black)"
						size="md"
						title={translate("common.save")}
						onClick={onSave}
					/>
				);
			case "saving":
				return (
					<div className={styles.savingIndicator}>
						<CircularLoader size={20} />
						<span className={styles.savingText}>{translate("common.saving")}</span>
					</div>
				);
			case "saved":
				return (
					<CustomIconButton
						disabled={!hasUnsavedChanges}
						icon={icon.faSave}
						iconColor="var(--blue-500)"
						size="md"
						title={translate("common.saved")}
						onClick={onSave}
					/>
				);
			case "error":
				return (
					<div className={styles.errorIndicator}>
						<CustomIconButton
							icon={icon.faExclamationTriangle}
							iconColor="var(--red-500)"
							size="md"
							title={translate("common.save-error")}
							onClick={onSave}
						/>
						<span className={styles.errorText}>
							{translate("common.save-error") || "Erreur d'enregistrement"}
						</span>
					</div>
				);
			default:
				return (
					<CustomIconButton
						icon={icon.faSave}
						iconColor="var(--color-black)"
						size="md"
						title={translate("common.save")}
						onClick={onSave}
					/>
				);
		}
	};

	return <div className={styles.secondaryActionsWrapper}>{renderContent()}</div>;
};

export default SaveActionIndicator;
